<template>
  <div class="relative">
    <div class="absolute w-full flex top-50 -mt-5 text-gray-700 z-20">
      <div v-if="overflowingLeft" @click="scrollToLeft" class="hidden lg:block cursor-pointer bg-white w-12 h-12 mr-auto -ml-4 shadow rounded-full"> 
        <svg xmlns="http://www.w3.org/2000/svg" class="fill-current" viewBox="0 0 24 24"><path class="heroicon-ui" d="M14.7 15.3a1 1 0 0 1-1.4 1.4l-4-4a1 1 0 0 1 0-1.4l4-4a1 1 0 0 1 1.4 1.4L11.42 12l3.3 3.3z"/></svg>
      </div>
      <div v-if="overflowingRight" @click="scrollToRight" class="hidden lg:block cursor-pointer bg-white w-12 h-12 ml-auto -mr-4 shadow rounded-full"> 
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="fill-current"><path class="heroicon-ui" d="M9.3 8.7a1 1 0 0 1 1.4-1.4l4 4a1 1 0 0 1 0 1.4l-4 4a1 1 0 0 1-1.4-1.4l3.29-3.3-3.3-3.3z"/></svg>
      </div>
    </div>
    <div ref="wrapper" @scroll.passive="showOrHideArrows" class="scroll-smooth space-x-4 flex overflow-x-auto flex-no-wrap py-6">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CardSlider',
    data() {
      return {
        overflowingLeft: false,
        overflowingRight: false,
      }
    },
    mounted() {
      this.showOrHideArrows()
    },
    methods: {
      scrollToLeft() {
        let newScrollLeft = this.$refs.wrapper.scrollLeft - 200
        // Scroll all the way to begining if less than 100 px left
        if (newScrollLeft < 100) {
          newScrollLeft = 0
        }
        this.$refs.wrapper.scrollLeft = newScrollLeft
      },
      scrollToRight() {
        const scrollLeftMax = this.scrollWidth() - this.clientWidth()
        let newScrollLeft = this.$refs.wrapper.scrollLeft + 200
        // Scroll all the way to the end if less than 100 px left
        if (scrollLeftMax - newScrollLeft < 100) {
          newScrollLeft = scrollLeftMax
        }
        this.$refs.wrapper.scrollLeft = newScrollLeft
      },
      showOrHideArrows() {
        this.overflowingLeft = this.clientWidth() < this.scrollWidth() &&
          this.scrollLeft() > 16
        this.overflowingRight = this.scrollLeft() + this.clientWidth() < this.scrollWidth()
      },
      clientWidth() {
        return this.$refs.wrapper.clientWidth
      },
      scrollWidth() {
        return this.$refs.wrapper.scrollWidth
      },
      scrollLeft() {
        return this.$refs.wrapper.scrollLeft
      },
    }
  }
</script>
<style lang="scss" scoped>
  .scroll-smooth {
    scroll-behavior: smooth;
  }
</style>
